import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@design-system';

interface PartnerInviteAcknowledgeDialogProps {
  open: boolean;
  inviteeName: string;
  isSending: boolean;
  // Reframed EDJ copy: an invite is a factual indication of who the advisor works with, not a
  // directive that their client data be shared automatically.
  edjMode?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function PartnerInviteAcknowledgeDialog({
  open,
  inviteeName,
  isSending,
  edjMode = false,
  onConfirm,
  onCancel,
}: PartnerInviteAcknowledgeDialogProps) {
  const who = inviteeName.trim() || 'this person';

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => !isOpen && !isSending && onCancel()}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-primary-dark">
            {edjMode ? 'How working with invited partners works' : 'How sharing works with invited partners'}
          </DialogTitle>
          <DialogDescription className="text-foreground">
            {who} doesn't have a Waterlily account yet, so they need to create one first.
            <br />
            {edjMode
              ? "Once they do, they'll be available as a distribution partner you work with. Based on your election, Waterlily shares client data with them to support your collaboration, under Waterlily's client agreement."
              : 'Once they do, your client data will automatically be shared with them as your distribution partner — based on the consent your clients give at intake.'}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={isSending}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isSending}
          >
            {isSending ? 'Sending…' : edjMode ? 'Send invite' : 'Acknowledge & send invite'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
